module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Register Form":"Register Form","Selected Phase":"Selected Phase","Pesticide Form":"Pesticide Form"},"es":{"Register Form":"Formulario de registro","Selected Phase":"Fase seleccionada","Pesticide Form":"Forma de pesticida"},"sw":{"Register Form":"Register Form","Selected Phase":"Selected Phase","Pesticide Form":"Pesticide Form"}}')
  delete Component.options._Ctor
}
